const initialState = {
    anchor: 'left',
    fazendaCertificado: [],
    open: false,
    id: '',
    data_validade: '',
    data_cadastro: '',
    usuario_cadastro: '',
    data_exclusao: '',
    usuario_exclusao: '',
    id_fazenda: 0,
    nome: '',
    chave: '',
    senha: '',
    caminho_certificado: ''
};

export function fazendaCertificado(state = initialState, action) {
    switch (action.type) {
        case 'FETECHED_ALL_FAZENDA_CERTIFICADO':
            return {
                ...state,
                fazendaCertificado: action.fazendaCertificado
            };
        case 'FAZENDA_CERTIFICADO_DETAIL':
            return {
                ...state,
                id: action.id,
                data_validade: action.data_validade,
                data_cadastro: action.data_cadastro,
                usuario_cadastro: action.usuario_cadastro,
                data_exclusao: action.data_exclusao,
                usuario_exclusao: action.usuario_exclusao,
                id_fazenda: action.id_fazenda,
                chave: action.chave,
                nome: action.nome,
                senha: action.senha,
                caminho_certificado: action.caminho_certificado
            };
        case "FAZENDA_CERTIFICADO_UPDATED":
            return state;
        case "HANDLE_ON_CHANGE":
            return {
                ...state,
                [action.props]: action.value
            };
        case 'FAZENDA_CERTIFICADO_CLEAR':
            return {
                ...state,
                anchor: 'left',
                fazendaCertificado: [],
                open: false,
                id: '',
                data_validade: '',
                data_cadastro: '',
                usuario_cadastro: '',
                data_exclusao: '',
                usuario_exclusao: '',
                id_fazenda: 0,
                chave: '',
                nome: '',
                senha: '',
                caminho_certificado: ''
            };
        case 'FAZENDA_CERTIFICADO_CHAVE_CLEAR':
            const { fazendaCertificado, totalRegistros } = state;

            return {
                ...initialState,
                fazendaCertificado,
                totalRegistros
            };
        default:
            return state
    }
}
